import { createContext } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'

const client = new QueryClient()

export const QueryContext = createContext(client)

interface QueryProviderProps {
    children: React.ReactNode
}

export const QueryProvider = ({ children }: QueryProviderProps) => {
    return (
        <QueryClientProvider client={client}>
            {children}
        </QueryClientProvider>
    )
}
